<template>
	<div class="carousel">
		<div 
			class="carousel__content"
			:class="{ ready: spotlight }"
		>
			<h1>Let us do the thinking for you</h1>
			<h2>Making applications to support your businesses</h2>
			<h3>Contact: <a href="mailto:info@akgdynamics.com">info@akgdynamics.com</a></h3>

			<div 
				class="carousel__products"
				:class="{ ready: products }"
			>
				<div class="carousel__products--title">Products</div>
				<div class="carousel__products--product">
					<strong>ADiMS</strong>
					<p>Approved Driving Instructor's Management System - Online Diary</p>
					<a href="https://www.adims.co.uk/" target="_blank">Visit ADiMS</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				spotlight: false,
				products: false
			}
		},	
		mounted() {
			setTimeout(() => {
				this.spotlight = true;

				setTimeout(() => {
					this.products = true;
				}, 1000);
			}, 1000);
		}
	};
</script>

<style lang="scss" scoped>
	.carousel {
		width: 100vw;
		height: 100vh;
		background: url('../assets/media/img/banner.jpg');
		background-size: cover;
		background-position: center;
		position: relative;

		color: $white;

		display: flex;
		align-items: center;
		padding-left: 1em;

		&:before {
			content: "";
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			background: rgba($black, 0.9);
			z-index: 0;
		}

		&__content {
			position: relative;
			z-index: 1;
			width: 80%;
			margin-top: 2em;

			h1, h2, h3 {
				margin: 0;

				transform: translateY(30px);
				opacity: 0;
			}

			&.ready {
				h1, h2, h3 {
					transform: translateY(0px);
					opacity: 2;
					transition: all 1s ease;
				}
			}

			h1 {
				margin-bottom: 0.5em;
				font-weight: 600;
			}

			h2 {
				font-size: 1.2em;
				font-weight: 300;
			}

			h3 {
				font-weight: 300;
				font-size: 1em;
				margin-top: 1em;
				a {
					color: $red;
					text-decoration: none;
				}
			}
		}

		&__products {
			margin-top: 8em;
			font-size: 0.85em;
			opacity: 0;

			&.ready {
				opacity: 2;
				transition: all 1s ease;
			}

			&:before {
				content: "";
				display: block;
				width: 100%;
				height: 1px;
				background:rgba($white, 0.3);
				margin-bottom: 1.5em;
			}

			&--title {
				font-size: 0.9em;
				text-transform: uppercase;
				letter-spacing: 2px;
				padding-left: 0.75em;
				color: $red;
				position: relative;

				&:before {
					content: "";
					display: block;
					width: 3px;
					height: 100%;
					background: $red;
					position: absolute;
					left: 0;
				}
			}

			&--product {
				margin: 1em 0;
				p {
					margin: 0;
				}

				a {
					cursor: pointer;
					margin-top: 10px;
					color: $red;
					text-decoration: none;
					display: block;
				}
			}
		}
	}

	@include tablet {
		.carousel {
			padding: 0;
			font-size: 1.2em;

			&__content {
				text-align: center;
				width: calc(100% - 2em);
				font-size: 1.1em;

				h3 {
					display: none;
				}
			}

			&__products {
				margin-top: 6em;
				&:before {
					display: none;
				}

				&--title {
					display: inline-block;
				}
			}

		}
	}

	@include largeDesktop {
		.carousel {
			&__content {
				h1 {
					font-size: 3em;
				}
				h2 {
					font-size: 1.6em;
				}
			}
		}
	}
</style>